import React from 'react'

function Alert({ type, header, description }) {
  return (
    <div className={`app-alert app-alert--${type}`} role='alert'>
      {header && <p className='app-alert__header'>{header}</p>}
      {description && <p className='app-alert__description'>{description}</p>}
    </div>
  )
}

Alert.defaultProps = {
  type: 'warning',
}

export default Alert



// WEBPACK FOOTER //
// client/components/util/alert.js